// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"412":"1b9e4cf7","739":"3d9dad4c"}[chunkId] + ".chunk.js";
};